var HashDialogView = require('hashdialogview');


var ForgotPasswordDialogView = HashDialogView.extend({
    el: '#forgotPasswordContent',
    wrapper: $('#forgotPasswordContainer'),
    initialize: function (options) {
        this.bind('close', function () {
            this.hideError();
            this.hideSuccess();
        }, this);
        HashDialogView.prototype.initialize.call(this, options);
        
        this.email = this.$('[name=email]');
        this.error = this.$('.userError');
        this.success = this.$('.userSuccess');
        
        this.router.route('?/password-reset', 'passwordReset', _.bind(this.show, this));
    },
    events: $.extend({}, HashDialogView.prototype.events, {
        'submit form': 'submit'
    }),
    afterShow: function () {
        this.focusEmail();
    },
    submit: function (e) {
        e.preventDefault();
        this.hideError();
        this.hideSuccess();
        var email = this.email.val();
        this.model.forgotPassword(email, _.bind(function (response) {
            if (response.success) {
                this.showSuccess(email);
            } else {
                var msg;
                switch (response.message) {
                case 'email':
                    msg = 'Invalid email address';
                    break;
                case "invalid_form_token":
                    msg = 'Invalid form token';
                    break;
                default:
                    msg = 'Error sending password reset';
                }
                this.showError(msg);
            }
        }, this));
    },
    showSuccess: function (email) {
        this.success.fadeIn('fast');
    },
    showError: function (message) {
        this.error.text(message).fadeIn('fast');
    },
    focusEmail: function () {
        this.email.val($('.signin [name=email]').val());
        this.email.focus().select();
    },
    hideSuccess: function () {
        this.success.hide();
    },
    hideError: function () {
        this.error.hide();
    }
});


module.exports = ForgotPasswordDialogView;



//////////////////
// WEBPACK FOOTER
// ./app/src/view/forgotpassworddialogview.js
// module id = 1Utr
// module chunks = 3